import React, { useState } from 'react';
import {
    FormControl,
    Select,
    MenuItem,
    InputBase,
    IconButton,
    SelectChangeEvent,
    Grid,
    Box,
} from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';

interface CustomSelectOptionProps {
    value: string;
    onChange: (event: SelectChangeEvent<any>) => void;
    options: { value: string; label: string }[];
    icon?: JSX.Element;
}

const AccountStatusOption: React.FC<CustomSelectOptionProps> = ({
    value,
    onChange,
    options,
    icon,
}) => {
    const [open, setOpen] = useState(false);

    const handleOpen = () => {
        setOpen(true);
    };

    const handleClose = () => {
        setOpen(false);
    };

    const handleValueChange = (event: SelectChangeEvent<any>) => {
        onChange(event);
        handleClose();
    };

    return (
        <FormControl>
            <Grid container alignItems="center">
                <Grid item xs={10}>
                    <Select
                        value={value}
                        onChange={handleValueChange}
                        open={open}
                        onClose={handleClose}
                        onOpen={handleOpen}
                        input={<InputBase />}
                        IconComponent={() => null}
                        renderValue={(selected) => {
                            const selectedOption = options.find(opt => opt.value === selected);
                            return (
                                <Box sx={{
                                    display: 'flex', alignItems: 'center', gap: 1,
                                    px: 2
                                }}>
                                    {icon}
                                    <span>{selectedOption ? selectedOption.label : ""}</span>
                                </Box>
                            );
                        }}
                        MenuProps={{
                            anchorOrigin: {
                                vertical: 'bottom',
                                horizontal: 'left',
                            },
                            transformOrigin: {
                                vertical: 'top',
                                horizontal: 'left',
                            },
                        }}
                    >
                        {options.map((option, index) => (
                            <MenuItem key={index} value={option.value}
                                sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                                <span style={{ color: option.value === "approve" ? "#28a745" : "#ffc107" }}>
                                    ●
                                </span>
                                {option.label}
                            </MenuItem>
                        ))}
                    </Select>
                </Grid>
                <Grid item xs={2}>
                    <IconButton
                        disableRipple
                        sx={{
                            padding: 0,
                            '&:hover': { backgroundColor: 'transparent' },
                        }}
                        onClick={handleOpen}
                    >
                        <ExpandMoreIcon />
                    </IconButton>
                </Grid>
            </Grid>
        </FormControl>
    );
};

export default AccountStatusOption;
